import { CropStyleFillPattern } from "@omnia/shared/generated/enums";
import { RGBColor } from "@omnia/shared/types";
import { param } from "../../omnia";
import { CropStyle, PurposeStyle, } from "../types";
import { StyleRow, StyleRowProps } from "./StyleRow";

export interface CropPurposeRowProps {
    crop: CropStyle;
    purpose: PurposeStyle;
    onChange: StyleRowProps["onChange"];
}

const cropPurposeLabels = new Map(param.CropPurpose().map((x) => [x.value, x.text]));

function getPurposeLabel(purpose: number) {
    return cropPurposeLabels.get(purpose) ?? `Purpose #${purpose}`;
}

export const CropPurposeRow = ({ crop, purpose, onChange }: CropPurposeRowProps) => {
    const effectiveColor: RGBColor =
        purpose.color ?? crop.color ?? purpose.defaultStyle?.color ?? crop.defaultStyle?.color;
    const effectivePattern: CropStyleFillPattern =
        purpose.pattern ?? crop.pattern ?? purpose.defaultStyle?.pattern ?? crop.defaultStyle?.pattern;

    return (
        <StyleRow
            className="purpose"
            effectiveStyle={{ color: effectiveColor, pattern: effectivePattern }}
            initialStyle={{ color: purpose.initialState.color, pattern: purpose.initialState.pattern }}
            selectedStyle={{ color: purpose.color, pattern: purpose.pattern }}
            label={getPurposeLabel(purpose.purpose)}
            typeLabel="Purpose"
            onChange={onChange}
        />
    );
};
